import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import PageContainer from '../page-container';
import Top from './top';
import Games from './games';
import Compontens from '../../components';

import Triggers from '../../../lib/triggers';

export default () => {
    const location = useLocation();

    useEffect(() => {
        Triggers.page_view({
            page: "home"
        });
    }, [location]);

    useEffect(() => {
        Compontens.Loader.close();
    }, []);

    return (
        <PageContainer>
            <div className="page home">
                <Top />
                <Compontens.Winners />
                <Games />

                <Compontens.DepositBonus />
                <Compontens.Footer />
            </div>
        </PageContainer> 
    )
}